
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as BackIconComponent } from "./back-icon.svg";

export const BackIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <BackIconComponent {...props} />;
};
